import { km } from "../../../../date-fns/locale/km.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    km
  }
};